export default __webpack_public_path__ + "static/media/tutorial2-6.934c017d.png";